import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  useGetAnalytics,
  useGetEvent,
  useGetEventSummary
} from 'legacy/events/hooks';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import OverallNumbers from 'legacy/events/components/analytics/OverallNumbers';
import TrackingLinks from 'legacy/events/components/analytics/TrackingLinks';
import AnalyticsActions from 'legacy/events/components/analytics/AnalyticsActions';
import Header from 'legacy/common/components/wysiwyg-form/Header';
import { useEventEditorContext } from '../../contexts/EventEditorContext';

const TrackingLinksPage: React.FC = () => {
  const { t } = useTranslation(['events']);
  const {
    eventId,
    isDraft,
    isEditing,
    isLoading: headerIsLoading,
    lastUpdated,
    handleBack,
    navigateToEventSettings
  } = useEventEditorContext();

  const { data: event } = useGetEvent(eventId);

  const {
    data: analytics,
    isLoading: isLoadingAnalytics,
    error
  } = useGetAnalytics(eventId, {
    enabled: event?.isOrganizer
  });
  const { data: eventSummary } = useGetEventSummary(
    eventId,
    event?.isOrganizer
  );

  const payoutAmount = eventSummary?.totals?.payoutAmount || 0;
  const ticketsSold = eventSummary?.totals?.ticketsSold || 0;

  return (
    <>
      <Header
        isDraft={isDraft}
        isEditing={isEditing}
        title={t('events:settings.trackingLinks.page.title')}
        isLoading={headerIsLoading}
        lastUpdated={lastUpdated}
        onBack={handleBack}
        onMenuClick={navigateToEventSettings}
      />
      <FadeIn>
        <div className="pt-[36x] md:pt-[90px] -mt-[36px] pb-20 md:mx-auto">
          <OverallNumbers
            error={error}
            views={analytics?.views}
            sales={ticketsSold}
            revenue={payoutAmount}
            isLoading={isLoadingAnalytics}
          />

          <TrackingLinks trackingLinks={analytics?.trackingLinks} />
        </div>
      </FadeIn>

      <AnalyticsActions eventId={eventId} />
    </>
  );
};

export default TrackingLinksPage;
